(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cs-home-route-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cs-home-route-hero')) {
    customElements.define('cs-home-route-hero', class extends HTMLElement {
      connectedCallback() {
        if (this._connected) return;
        this._connected = true;
        this.track = this.querySelector('.cs-route-hero__track');
        this.slides = [...this.querySelectorAll('[data-route-slide]')];
        this.tabs = [...this.querySelectorAll('[data-route-index]')];
        this.index = 0;
        if (this.slides.length < 2) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.interacted = false;
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        this.prepareGhost(this.querySelector('[data-ghost="last"]'), this.slides[this.slides.length - 1]);
        this.prepareGhost(this.querySelector('[data-ghost="first"]'), this.slides[0]);
        this.classList.add('is-ready');
        this.setActive(0);
        this.center(this.slides[0], false);
        this.querySelector('[data-route-prev]').addEventListener('click', () => this.advance(-1), options);
        this.querySelector('[data-route-next]').addEventListener('click', () => this.advance(1), options);
        this.tabs.forEach((tab, index) => tab.addEventListener('click', () => this.goTo(index), options));
        this.track.addEventListener('pointerdown', () => { this.interacted = true; }, { ...options, passive: true });
        this.track.addEventListener('touchstart', () => { this.interacted = true; }, { ...options, passive: true });
        this.track.addEventListener('wheel', event => {
          if (event.shiftKey || Math.abs(event.deltaX) > Math.abs(event.deltaY)) this.interacted = true;
        }, { ...options, passive: true });
        this.track.addEventListener('scroll', () => {
          clearTimeout(this.settleTimer);
          this.settleTimer = setTimeout(() => this.settle(), 140);
        }, { ...options, passive: true });
        this.track.addEventListener('scrollend', () => this.settle(), options);
        this.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          if (!event.target.closest('.cs-route-hero__navigation') && event.target !== this.track) return;
          event.preventDefault();
          if (event.key === 'Home') this.goTo(0);
          else if (event.key === 'End') this.goTo(this.slides.length - 1);
          else this.advance(event.key === 'ArrowRight' ? 1 : -1);
        }, options);
        this.addEventListener('shopify:block:select', event => {
          const selected = event.target.closest('[data-route-slide]');
          const index = this.slides.indexOf(selected);
          if (index >= 0) this.goTo(index);
        }, options);
        this.resize = new ResizeObserver(() => {
          clearTimeout(this.resizeTimer);
          this.resizeTimer = setTimeout(() => this.center(this.slides[this.index], false), 80);
        });
        this.resize.observe(this.track);
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.resize?.disconnect();
        clearTimeout(this.settleTimer);
        clearTimeout(this.resizeTimer);
        this._connected = false;
      }
      prepareGhost(ghost, original) {
        const copy = original.cloneNode(true);
        copy.querySelectorAll('a').forEach(link => {
          const label = document.createElement('span');
          label.className = link.className;
          label.append(...link.childNodes);
          link.replaceWith(label);
        });
        copy.querySelectorAll('[id]').forEach(element => element.removeAttribute('id'));
        ghost.className = original.className.replace('cs-route-hero__slide ', 'cs-route-hero__ghost ').replace(' is-active', '');
        ghost.setAttribute('style', original.getAttribute('style'));
        ghost.replaceChildren(...copy.childNodes);
      }
      center(element, smooth) {
        if (!element) return;
        const left = element.getBoundingClientRect().left - this.track.getBoundingClientRect().left + this.track.scrollLeft - (this.track.clientWidth - element.offsetWidth) / 2;
        this.track.scrollTo({ left, behavior: smooth && !this.reducedMotion.matches ? 'smooth' : 'instant' });
      }
      setActive(index) {
        this.querySelectorAll('[data-ghost]').forEach(ghost => ghost.classList.remove('is-active'));
        this.index = index;
        this.slides.forEach((slide, itemIndex) => {
          slide.classList.toggle('is-active', itemIndex === index);
          slide.inert = itemIndex !== index;
          slide.setAttribute('aria-hidden', String(itemIndex !== index));
        });
        this.tabs.forEach((tab, itemIndex) => tab.setAttribute('aria-pressed', String(itemIndex === index)));
      }
      goTo(index) {
        this.interacted = true;
        clearTimeout(this.settleTimer);
        this.setActive(index);
        this.center(this.slides[index], true);
      }
      advance(direction) {
        this.interacted = true;
        const next = this.index + direction;
        if (next < 0 || next >= this.slides.length) {
          const targetIndex = next < 0 ? this.slides.length - 1 : 0;
          this.setActive(targetIndex);
          const ghost = this.querySelector(next < 0 ? '[data-ghost="last"]' : '[data-ghost="first"]');
          ghost.classList.add('is-active');
          this.center(ghost, true);
        } else this.goTo(next);
      }
      settle() {
        clearTimeout(this.settleTimer);
        const center = this.track.getBoundingClientRect().left + this.track.clientWidth / 2;
        if (!this.interacted) {
          this.setActive(0);
          const first = this.slides[0];
          if (Math.abs(first.getBoundingClientRect().left + first.offsetWidth / 2 - center) > 1) this.center(first, false);
          return;
        }
        const panels = [...this.track.children];
        const nearest = panels.reduce((best, panel) => {
          const distance = Math.abs(panel.getBoundingClientRect().left + panel.offsetWidth / 2 - center);
          return distance < best.distance ? { panel, distance } : best;
        }, { panel: null, distance: Infinity }).panel;
        if (!nearest) return;
        if (nearest.hasAttribute('data-ghost')) {
          const index = nearest.dataset.ghost === 'first' ? 0 : this.slides.length - 1;
          this.setActive(index);
          this.center(this.slides[index], false);
        } else this.setActive(this.slides.indexOf(nearest));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-strap-selector"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cs-strap-selector')) {
    class CsStrapSelector extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        document.addEventListener('pointerdown', () => { this.dataset.input = 'pointer'; }, { ...options, capture: true });
        document.addEventListener('keydown', (event) => {
          if (!event.isComposing && !event.metaKey && !event.ctrlKey && !event.altKey && !['Shift', 'Control', 'Alt', 'Meta'].includes(event.key)) {
            delete this.dataset.input;
          }
        }, { ...options, capture: true });
        this.choices = Array.from(this.querySelectorAll('[data-style-choice]'));
        this.panels = Array.from(this.querySelectorAll('[data-style-panel]'));
        this.addEventListener('click', (event) => {
          const choice = event.target.closest('[data-style-choice]');
          if (choice && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
            event.preventDefault();
            event.stopPropagation();
            this.changeStyle(choice.dataset.styleChoice);
          }
          const back = event.target.closest('[data-change-style]');
          if (back) {
            event.preventDefault();
            event.stopPropagation();
            this.changeStyle('');
          }
          if (event.target.closest('[data-strap-help]')) this.querySelector('#cs-strap-connections').open = true;
          const product = event.target.closest('[data-strap-link]');
          if (product) this.emit('product', { product: product.dataset.strapLink, connection: product.dataset.connection });
        }, options);
        window.addEventListener('popstate', () => this.readLocation(), options);
        document.addEventListener('shopify:block:select', (event) => {
          const choice = this.choices.find(item => item.dataset.blockId === event.detail?.blockId);
          if (choice) {
            this.cancelStyleTransition();
            this.select(choice.dataset.styleChoice, false);
          }
        }, options);
        this.motionViewportWidth = window.innerWidth;
        window.addEventListener('resize', () => {
          if (window.innerWidth === this.motionViewportWidth) return;
          this.motionViewportWidth = window.innerWidth;
          const candidate = this.requestedStyle;
          this.cancelStyleTransition();
          if (candidate !== undefined) this.select(candidate, true);
        }, options);
        this.readLocation();
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.cancelStyleTransition();
      }
      changeStyle(candidate) {
        candidate = this.panels.some(panel => panel.dataset.stylePanel === candidate) ? candidate : '';
        if ((this.requestedStyle ?? this.dataset.selected ?? '') === candidate) return;
        if (!this.isTransitioning && candidate && !this.dataset.selected) this.overviewScroll = window.scrollY;
        this.requestedStyle = candidate;
        if (!this.isTransitioning) this.transitionStyle();
      }
      cancelStyleTransition() {
        this.motionVersion = (this.motionVersion || 0) + 1;
        this.motionAnimations?.forEach(animation => animation.cancel());
        this.motionAnimations = [];
        this.clearStyleLayout();
        this.isTransitioning = false;
        this.requestedStyle = undefined;
      }
      clearStyleLayout() {
        if (this.motionStage) {
          this.motionStage.style.height = '';
          this.motionStage.style.overflow = '';
        }
        if (this.motionContent) this.motionContent.style.opacity = '';
      }
      async transitionStyle() {
        this.isTransitioning = true;
        const version = this.motionVersion = (this.motionVersion || 0) + 1;
        const current = () => this.isConnected && this.motionVersion === version;
        try {
          while (current() && this.requestedStyle !== (this.dataset.selected || '')) {
            const stage = this.motionStage = this.querySelector('[data-style-stage]');
            const mobile = window.matchMedia('(max-width: 699px)').matches;
            const content = this.motionContent = mobile ? stage : this.querySelector('.cs-straps__panels');
            const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            if (!stage || !content || reducedMotion || typeof stage.animate !== 'function') {
              this.commitStyle(this.requestedStyle, reducedMotion);
              break;
            }
            const startHeight = stage.getBoundingClientRect().height;
            stage.style.height = `${startHeight}px`;
            stage.style.overflow = 'hidden';
            const outgoing = content.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 80, easing: 'ease-in', fill: 'forwards' });
            this.motionAnimations = [outgoing];
            await outgoing.finished.catch(() => {});
            if (!current()) return;
            content.style.opacity = '0';
            outgoing.cancel();
            const candidate = this.requestedStyle;
            const previous = this.choices.find(item => item.dataset.styleChoice === this.dataset.selected);
            const originalScroll = window.scrollY;
            this.select(candidate, true);
            stage.style.height = 'auto';
            const endHeight = stage.getBoundingClientRect().height;
            stage.style.height = `${startHeight}px`;
            const height = stage.animate([{ height: `${startHeight}px` }, { height: `${endHeight}px` }], { duration: 220, easing: 'cubic-bezier(.22, 1, .36, 1)', fill: 'forwards' });
            const incoming = content.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 180, delay: 20, easing: 'ease-out', fill: 'both' });
            this.motionAnimations = [height, incoming];
            this.positionStyle(candidate, previous, originalScroll, false);
            if (candidate) this.emit('style');
            await Promise.all(this.motionAnimations.map(animation => animation.finished.catch(() => {})));
            if (!current()) return;
            this.clearStyleLayout();
            this.motionAnimations.forEach(animation => animation.cancel());
            this.motionAnimations = [];
          }
        } catch {
          if (current()) this.commitStyle(this.requestedStyle, true);
        } finally {
          if (current()) {
            this.motionAnimations?.forEach(animation => animation.cancel());
            this.motionAnimations = [];
            this.clearStyleLayout();
            this.isTransitioning = false;
            this.requestedStyle = undefined;
          }
        }
      }
      commitStyle(candidate, reducedMotion) {
        const previous = this.choices.find(item => item.dataset.styleChoice === this.dataset.selected);
        const originalScroll = window.scrollY;
        this.select(candidate, true);
        this.positionStyle(candidate, previous, originalScroll, reducedMotion);
        if (candidate) this.emit('style');
      }
      positionStyle(candidate, previous, originalScroll, reducedMotion) {
        const mobile = window.matchMedia('(max-width: 699px)').matches;
        const heading = candidate
          ? this.panels.find(panel => !panel.hidden)?.querySelector('[data-panel-heading]')
          : this.querySelector('[data-style-heading]');
        const focusTarget = candidate ? heading : previous;
        focusTarget?.focus({ preventScroll: true });
        if (heading) {
          const top = heading.getBoundingClientRect().top + window.scrollY;
          const margin = parseFloat(getComputedStyle(heading).scrollMarginTop) || 150;
          let target = Math.max(0, top - margin);
          if (!candidate && Number.isFinite(this.overviewScroll)) target = this.overviewScroll;
          else if (mobile && top - originalScroll >= margin && top - originalScroll < window.innerHeight - 150) target = originalScroll;
          if (Math.abs(window.scrollY - target) > 1) window.scrollTo({ top: target, behavior: reducedMotion ? 'instant' : 'smooth' });
        }
      }
      readLocation() {
        this.cancelStyleTransition();
        const url = new URL(window.location.href);
        const hashPanel = this.panels.find(panel => '#' + panel.id === url.hash);
        this.select(hashPanel?.dataset.stylePanel || url.searchParams.get('strap_style') || '', false);
      }
      select(candidate, writeLocation) {
        const selected = this.panels.some(panel => panel.dataset.stylePanel === candidate) ? candidate : '';
        this.panels.forEach(panel => { panel.hidden = panel.dataset.stylePanel !== selected; });
        this.choices.forEach(choice => {
          if (choice.dataset.styleChoice === selected) choice.setAttribute('aria-current', 'true');
          else choice.removeAttribute('aria-current');
        });
        if (selected) this.dataset.selected = selected;
        else delete this.dataset.selected;
        if (writeLocation) {
          const url = new URL(window.location.href);
          if (selected) url.searchParams.set('strap_style', selected);
          else url.searchParams.delete('strap_style');
          url.searchParams.delete('strap_design');
          url.searchParams.delete('strap_connection');
          if (url.hash.startsWith('#cs-') || url.hash === '#strap-finder') url.hash = '';
          window.history.replaceState(window.history.state, '', url);
        }
      }
      emit(action, extra = {}) {
        this.dispatchEvent(new CustomEvent('cs:strap-selector', { bubbles: true, detail: { action, design: this.dataset.selected || '', ...extra } }));
      }
    }
    customElements.define('cs-strap-selector', CsStrapSelector);
  }

  } catch(e) { console.error(e); }
})();
})();
